import FullLoading from '../../../../CompUtils/FullLoading';
import { useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
  cleanFile,
  getPuestosPublicos,
  useDenominaciones,
} from '../../../../../appStore/denominaciones';
import { useConcurso } from '../../../../../providers/ConcursoProvider';
import { CommonRoot } from '../../../../CompUtils/CommonRoot';
import { FileModal } from '../../../../CompUtils/FileModal';
import { MainTablePublica } from './MainTablePublica';
import {
  PuestosTableProvider,
  PuestoTableProps,
} from '../../../Gestion/TramitarConcursos/Commons/PuestosTable/PuestosTableProvider';

export const TablaDenominacionesPublicas = (props: PuestoTableProps) => {
  const { idLlamadoConcurso } = useConcurso();
  const dispatch = useDispatch();
  const { error, dataPublico, file, loading } = useDenominaciones();
  useEffect(() => {
    dispatch(getPuestosPublicos({ idLlamadoConcurso }));
  }, [dispatch, idLlamadoConcurso]);
  return (
    <PuestosTableProvider {...props}>
      <CommonRoot>
        {error !== '' && (
          <p className="text-danger">
            <small>{error}</small>
          </p>
        )}
        {dataPublico?.length === 0 && error === '' && (
          <Alert variant="primary"> No hay Denominaciones cargadas para este concurso !</Alert>
        )}
        {dataPublico?.length !== 0 && <MainTablePublica />}
      </CommonRoot>
      <FullLoading show={loading} />

      <FileModal file={file} onClose={() => dispatch(cleanFile())} title="Bases y condiciones" />
    </PuestosTableProvider>
  );
};
